import { Context } from '@shopify/app-bridge-react';
import { Cart, Pos, Toast } from "@shopify/app-bridge/actions";
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import GlobalHelper from '../../common/GlobalHelper.jsx';
import Icon from '../../common/icon/icon.component.jsx';
import AnchorWrapper from '../../common/rich-text/feature-protection-wrappers/anchorWrapper.component';
import ShopifyAppContext from "../../shopify/shopifyappcontext.js";
import ReceivePaymentDocuments from "./receivePaymentDocuments.component.jsx";
const messages = defineMessages({
    "payment_intent_error": {
        id: 'invoice.pos.payment_intent_error',
        defaultMessage: '"Error creating payment intent. Please try again."',
    },
})

class ReceivePayment extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            amount: '',
            contactId: '',
            customerAccount: '',
            isLoading: false,
            contact: this.props.contact || [],
            contactName: this.props.contact.name || '',
            currency: 'USD',
            shopifyCustomer: this.props.shopifyCustomer,
            activeTab: 'invoices',
            listing: '',
        }
        ReceivePayment.contextType = Context;
        this.refreshCustomerAccount = this.refreshCustomerAccount.bind(this)
        this.onCreatePaymentCart = this.onCreatePaymentCart.bind(this)
        this.setPendingPaymentId = this.setPendingPaymentId.bind(this)
        this.changeTab = this.changeTab.bind(this)
    }

    componentDidMount() {
        const shopifyApp = this.context
        const cart = Cart.create(shopifyApp);
        cart.dispatch(Cart.Action.CLEAR);

        this.refreshCustomerAccount(this.state.contact.id)
    }

    refreshCustomerAccount(contactId) {
        if (!contactId) {
            contactId = this.state.contactId
        }
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            this.setState({
                customerAccount: res,
                contactId: contactId,
                listing: <ReceivePaymentDocuments
                    contactId={contactId}
                    contactName={this.state.contactName}
                    documentType={this.state.activeTab}
                    onCreatePaymentCart={this.onCreatePaymentCart}
                />
            })
        })
    }

    getTabs() {
        return ([
            {
                name: "invoices",
                module: '',
                iconValue: 'invoice',
                message: <FormattedMessage
                    id="customers.invoices.list.title_label"
                    defaultMessage="Invoices"
                />
            },
            {
                name: "quotes",
                module: '',
                iconValue: 'quote',
                message: <FormattedMessage
                    id="customers.quotes.list.title_label"
                    defaultMessage="Quotes"
                />
            },
            //{
            //    name: "orders",
            //    module: '',
            //    iconValue: 'order',
            //    message: <FormattedMessage
            //        id="customers.orders.list.title_label"
            //        defaultMessage="Orders"
            //    />
            //},

        ])
    }

    changeTab(e, tab) {
        this.setState({
            activeTab: tab,
            listing: <ReceivePaymentDocuments
                contactId={this.state.contactId}
                contactName={this.state.contactName}
                documentType={tab}
                onCreatePaymentCart={this.onCreatePaymentCart}
            />
        })
    }

    isDocumentChecked(documentId, documentPayments) {
        const pay = documentPayments.find(pay => pay.documentId === documentId)
        return pay ? pay.checked : false
    }

    onCreatePaymentCart(dueDocuments, documentPayments, amount) {
        this.setState({ isLoading: true })

        const shopifyApp = this.context
        const cart = Cart.create(shopifyApp);

        cart.dispatch(Cart.Action.SET_CUSTOMER, {
            data: {
                id: this.state.shopifyCustomer.id
            }
        });

        let documentLabel = dueDocuments.filter(doc => this.isDocumentChecked(doc.id, documentPayments)).map(doc => doc.identifier).join(",")

        const lineItemPayload = {
            price: amount,
            quantity: 1,
            title: "Payment for " + documentLabel,
            taxable: false,
        };

        cart.dispatch(Cart.Action.ADD_LINE_ITEM, {
            data: lineItemPayload
        });
        this.setPendingPaymentId(dueDocuments, documentPayments)
    }

    getDocumentAmount(documentId, documentPayments) {
        const pay = documentPayments.find(pay => pay.documentId === documentId)
        return pay ? pay.amount : 0
    }

    getTransactionFromType(documentId, documentPayments) {
        let amount = this.getDocumentAmount(documentId, documentPayments).toString()
        switch (this.state.activeTab) {
            case 'invoices':
                return {
                    "invoiceId": documentId,
                    "amount": amount
                }
            case 'quotes':
                return {
                    "quoteId": documentId,
                    "amount": amount
                }
            case 'orders':
                return {
                    "orderId": documentId,
                    "amount": amount
                }
        }
    }

    setPendingPaymentId(dueDocuments, documentPayments) {
        const shopifyApp = this.context
        const toastOptions = {
            message: this.props.intl.formatMessage(messages["payment_intent_error"]),
            duration: 5000,
            isError: true,
        };

        const toastError = Toast.create(shopifyApp, toastOptions);
        const cart = Cart.create(shopifyApp);
        const pos = Pos.create(shopifyApp);
        let currency = dueDocuments && dueDocuments.length > 0 ? dueDocuments[0].currency : 'USD'

        let transactions = dueDocuments.filter(doc => this.isDocumentChecked(doc.id, documentPayments)).map(doc => {
            return this.getTransactionFromType(doc.id, documentPayments)
        })

        let data = {
            "source": "back-office",
            "paymentType": "credit-card",
            "currency": currency,
            "transactions": transactions,
            "contactId": this.state.contact.id,
            "integrationKey": ShopifyAppContext.integrationKey,
            "externalCheckout": {
                "source": "pos",
            },
            "fingerprintId": GlobalHelper.getFingerprintId(),
        }

        AppContext.getApiClient().post('/payment-transactions', data).then(res => {
            let lastPayment = null
            let hash = ""
            if (!res.error && res.data.length > 0) {
                lastPayment = res.data[0].attributes.paymentTransactions[res.data[0].attributes.paymentTransactions.length - 1].attributes.payment
                hash = lastPayment && lastPayment.attributes.integratedPayment ? lastPayment.attributes.integratedPayment.attributes.hash : ""
            }
            if (lastPayment && hash) {
                cart.dispatch(Cart.Action.SET_LINE_ITEM_PROPERTIES, {
                    index: 0,
                    data: {
                        "_QM Payment Hash": hash,
                    },
                });
                pos.dispatch(Pos.Action.CLOSE);
            } else {
                toastError.dispatch(Toast.Action.SHOW);
                cart.dispatch(Cart.Action.CLEAR);
            }
            this.setState({ isLoading: false })
        })
    }


    render() {
        return <div>
            <div>
                <h3 className="mt-4 mb-4">
                    <strong>
                        {this.state.contact.name}
                    </strong>
                </h3>
            </div>
            <ul className="nav nav-tabs nav-justified">
                {this.getTabs().map((elem, index) => {
                    return (
                        <li className="nav-item" key={index}>
                            <AnchorWrapper
                                module={elem.module}
                                onClick={(e) => this.changeTab(e, elem.name)}
                                className={"nav-link " + (this.state.activeTab === elem.name ? 'active' : '')}
                                protectedClassName={"nav-link " + (this.state.activeTab === elem.name ? 'active' : '')}
                                premium={false}
                                protectionRule={elem.module === "" ? true : AppContext.accountFeatureIsEnabled(elem.module)}
                            >
                                <h6 className="p-0 m-0">
                                    <Icon value={elem.iconValue} className={'mr-2'} />
                                    {elem.message}
                                </h6>
                            </AnchorWrapper>
                        </li>
                    )
                })}
            </ul>
            {this.state.listing}
        </div>
    }
}

export default injectIntl(ReceivePayment);



// WEBPACK FOOTER //
// ./src/embed/shopify/receivePayment.component.jsx